import { PlannedCard } from './_PlannedCard';

export function CommerceReportsStub() {
  return (
    <PlannedCard
      title="Reports"
      blurb="Order volume by channel, fulfillment time (order to ship), inventory turns, top retailers by revenue, backorder rate, chargeback volume."
    />
  );
}
